import React from 'react';
import { IMAGES, OCCASIONS } from '../data';
import { Reveal } from './Reveal';
export function Occasions() {
  return <section id="tillfallen" className="w-full bg-skog py-28 text-warm md:py-40" data-id="element-113" data-mp="22nby0gtqlaam">
      <div className="mx-auto grid max-w-7xl gap-16 px-6 md:grid-cols-[1fr,1.1fr] md:gap-24 md:px-10" data-id="element-114" data-mp="1ylqfofyfo3t1">
        <div className="md:sticky md:top-32 md:self-start" data-id="element-115" data-mp="1togs75ulu27u">
          <Reveal data-id="element-116" data-mp="2qdocybneg7ap">
            <p className="mb-6 text-[12px] uppercase tracking-wide3 text-smorgul" data-id="element-117" data-mp="2qe7j6v3ot78w">
              För alla tillfällen
            </p>
            <h2 className="font-display text-4xl font-light leading-tight md:text-5xl" data-id="element-118" data-mp="2mddzyf16wgmc">
              Oavsett vad du planerar – så hjälper vi dig att hitta rätt.
            </h2>
          </Reveal>
          <Reveal delay={0.2} data-id="element-119" data-mp="2clhyqv3t4adw">
            <div className="mt-10 overflow-hidden rounded-sm" data-id="element-120" data-mp="2ckgminb21hul">
              <img src={IMAGES.tableCandlelight} alt="Dukat bord med säsongsrätter i levande ljus" className="h-72 w-full object-cover md:h-96" data-id="element-121" data-mp="3a2gng3ii93or" />
            </div>
          </Reveal>
        </div>

        <div data-id="element-122" data-mp="9cqyf6hjqhdp">
          <ul className="flex flex-wrap gap-x-3 gap-y-4" data-id="element-123" data-mp="9djy5ni386mc">
            {OCCASIONS.map((o, i) => <Reveal key={o} delay={Math.min(i * 0.03, 0.4)} data-id="element-124" data-mp="3rrt4m1zpmlbb" data-mpi={i}>
                <li className="rounded-full border border-warm/25 px-5 py-2.5 text-sm text-warm/90 transition-colors hover:border-smorgul hover:text-smorgul" data-id="element-125" data-mp="3rp6vvz131zri">
                  {o}
                </li>
              </Reveal>)}
          </ul>
        </div>
      </div>
    </section>;
}